import { KeycloakService } from '@europrocurement/l2d-keycloak';
import { useEffect, useRef } from 'react';

export const useSessionTimeout = (
    keycloakInstance: KeycloakService | null,
    onSessionExpired: () => void,
) => {
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (!keycloakInstance || !keycloakInstance.getTokenParsed()?.exp) {
            return () => {};
        }

        const scheduleTimeout = () => {
            const tokenParsed = keycloakInstance.getTokenParsed();
            if (!tokenParsed || !tokenParsed.exp) {
                return;
            }
            const timeLeft = tokenParsed.exp * 1000 - Date.now();
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(
                () => {
                    onSessionExpired();
                },
                Math.max(timeLeft, 0),
            );
        };

        scheduleTimeout();

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [keycloakInstance, onSessionExpired]);
};
